let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jLj2M")).then(() => parcelRequire('7WvbB'));